import { Circle, Polygon } from 'react-leaflet';
import {
  getIpawsAreaPolygonCoordinates,
  IPAWS_AREA_TYPES,
} from '../../../../../../utils/ipawsArea.utils';
import { getOutsideAreaPathOptions } from '../../../../utils/outsideArea.utils';

/**
 * Draws the outline of the next shape under the pointer. The outline turns the danger color
 * while the shape would be placed outside the authorized area.
 *
 * @param {Object} props
 * @param {Object|null} props.shape The shape that a click would place.
 * @param {string} props.severityColor The normal outline color.
 * @param {boolean} [props.isOutside=false] Whether the shape would be outside the area.
 * @returns {JSX.Element|null}
 */
const IpawsPlacementPreview = ({ shape, severityColor, isOutside = false }) => {
  if (!shape) return null;

  const previewPathOptions = {
    color: severityColor,
    fillColor: severityColor,
    fillOpacity: 0.12,
    weight: 2,
    dashArray: '6 4',
  };
  const pathOptions = isOutside
    ? getOutsideAreaPathOptions(previewPathOptions)
    : previewPathOptions;
  // Leaflet applies the outside class only when it creates the path, so a change remounts it.
  const outsideKey = isOutside ? 'outside' : 'inside';

  if (shape.type === IPAWS_AREA_TYPES.CIRCLE) {
    return (
      <Circle
        key={outsideKey}
        center={shape.center}
        radius={Number(shape.radiusKm) * 1000}
        pathOptions={pathOptions}
        // This is only a preview. Its click must reach the map and place the shape.
        interactive={false}
      />
    );
  }

  return (
    <Polygon
      key={outsideKey}
      positions={getIpawsAreaPolygonCoordinates(shape)}
      pathOptions={pathOptions}
      // This is only a preview. Its click must reach the map and place the shape.
      interactive={false}
    />
  );
};

export default IpawsPlacementPreview;
